<div class="pagination-component">
  @if(message){
  <div>{{ message }}</div>
  }
  <mc-pagination
    [totalpages]="totalPages"
    [currentpage]="currentPage"
    [visiblepages]="visiblePages"
    (pagechange)="pageChanged($event)"
  ></mc-pagination>
</div>
